
import { Checkbox } from "@/components/ui/checkbox";

interface Category {
  id: string;
  name: string;
  description?: string;
}

interface CategoryGroupProps {
  categories: Category[];
  selectedCategories: string[];
  onToggleCategory: (id: string) => void;
}

export default function CategoryGroup({
  categories,
  selectedCategories,
  onToggleCategory
}: CategoryGroupProps) {
  return (
    <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
      {categories.map(category => (
        <div key={category.id} className="flex items-start space-x-2">
          <Checkbox
            id={`category-${category.id}`}
            checked={selectedCategories.includes(category.id)}
            onCheckedChange={() => onToggleCategory(category.id)}
          />
          <label
            htmlFor={`category-${category.id}`}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
          >
            {category.name}
          </label>
        </div>
      ))}
    </div>
  );
}
